import React, {useEffect, useState} from "react";
import {Button, Form, Input, Modal, Select, notification} from "antd";
import {ProcessingStatusEnum} from "../../../../constants/status.constants";
import SharedService from "../../../../services/shared/service";
import {sanitize} from "../../../../utils/html.utils";
import CommentService from "../../../../services/comment/service";

const {TextArea} = Input;

const statusOptions = Object.keys(ProcessingStatusEnum).map((key) => ({
    label: ProcessingStatusEnum[key],
    value: key,
}));

const UpdateInvoiceModal = ({visible, onCancel, disableStatus, documentId, status, user}) => {
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (visible) {
            form.setFieldsValue({status, note: ""});
        }
    }, [visible, status, form]);

    const handleCancel = () => {
        form.resetFields();
        onCancel?.();
    };

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setIsLoading(true);

            const data = {
                id: documentId,
                status: values.status,
                comment: values.note,
                updatedBy: user.email,
                note: sanitize(values.note),
            };

            await SharedService.patch({token: user.token, data, url: "document"});
            await CommentService.AddComment({token: user.token, data, documentId});

            onCancel?.();
            window.location.reload();
        } catch (error) {
            console.error("Update invoice failed:", error);
            notification.error({message: "Failed to update invoice"});
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            title="Update Invoice"
            open={visible}
            onCancel={handleCancel}
            closable={true}
            width={560}
            footer={[
                <Button key="cancel" onClick={handleCancel} disabled={isLoading}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={isLoading}
                    onClick={handleSubmit}
                >
                    Update
                </Button>,
            ]}
        >
            <Form form={form} layout="vertical" requiredMark={false}>
                <Form.Item
                    name="note"
                    rules={[{required: true, message: "Notes are required"}]}
                    label={
                        <span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">
                            Notes <span style={{color: "#A4231D"}}>*</span>
                        </span>
                    }
                >
                    <TextArea
                        autoSize={{minRows: 4, maxRows: 8}}
                        placeholder="Add context for this status change"
                    />
                </Form.Item>

                <Form.Item
                    name="status"
                    rules={[{required: true, message: "Status is required"}]}
                    label={
                        <span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">
                            Processing Status <span style={{color: "#A4231D"}}>*</span>
                        </span>
                    }
                >
                    <Select
                        disabled={disableStatus}
                        placeholder="Select status"
                        options={statusOptions}
                        allowClear
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default UpdateInvoiceModal;
